import React from 'react'
import './Loader.css'
const Loader = () => {
  return (
    <div className='loader__main_container'>
      <span className="loader"></span>
    </div>
  )
}

export default Loader
